<template>
    <div class="animated fadeIn">
        <b-row class="document-view">
            <b-col lg="12">
                <b-card class="mt-0">
                    <b-tabs content-class="mt-0">
                        <b-tab title="Xem chi tiết thông tin tài sản đã gửi lên" active>
                            <b-card style="margin-top: 0">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-row>
                                        <b-col>
                                            <b-link v-b-toggle.accordion-sync-info>
                                                Thông tin đồng bộ
                                                <span class="when-opened pull-right">
                                                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                </span>
                                                <span class="when-closed pull-right">
                                                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                </span>
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                </b-card-header>
                                <b-collapse id="accordion-sync-info" visible role="tabpanel">
                                    <b-card-body>
                                        <b-row>
                                            <b-col md="6">
                                                <b-form-group label="Phần mềm đồng bộ: "
                                                              :label-cols="4"
                                                              label-class="label-bold"
                                                              :horizontal="true"
                                                              label-align="left">
                                                    <!--<b-form-input :value="asset.syncSourceType == 1 ?'Phần mềm quản lý tài sản công' : 'Phần mềm khác tại các đơn vị'" :title="asset.syncSourceType == 1 ?'Phần mềm quản lý tài sản công' : 'Phần mềm khác tại các đơn vị'" :readonly="true"></b-form-input>-->
                                                    <b-form-input :value="$store.getters.getSyncSourceType(asset.syncSourceType)" :title="$store.getters.getSyncSourceType(asset.syncSourceType)" :readonly="true"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="6">
                                                <b-form-group label="Ngày đồng bộ:"
                                                              :label-cols="4"
                                                              label-class="label-bold"
                                                              label-align="left"
                                                              :horizontal="true">
                                                    <b-form-input :value="asset.syncDate | formatTime" :title="asset.syncDate | formatTime" :readonly="true"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="6">
                                                <b-form-group label="Đơn vị đồng bộ:"
                                                              :label-cols="4"
                                                              label-class="label-bold"
                                                              :horizontal="true"
                                                              label-align="left">
                                                    <b-form-input :value="asset.syncUnitName" :title="asset.syncUnitName" :readonly="true"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="6">
                                                <b-form-group label="Tài khoản đồng bộ:"
                                                              :label-cols="4"
                                                              label-class="label-bold"
                                                              :horizontal="true"
                                                              label-align="left">
                                                    <b-form-input :value="asset.syncUserName" :title="asset.syncUserName" :readonly="true"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="6">
                                                <b-form-group label="Mã tài sản tại kho: "
                                                              title="Mã tài sản tại kho (tự động sinh)"
                                                              :label-cols="4"
                                                              label-class="label-bold"
                                                              :horizontal="true"
                                                              label-align="left">
                                                    <b-form-input :value="asset.code" :title="asset.code" :readonly="true"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="6">
                                                <b-form-group label="Mã tài sản tại đơn vị: "
                                                              :label-cols="4"
                                                              label-class="label-bold"
                                                              :horizontal="true"
                                                              label-align="left">
                                                    <b-form-input :value="asset.syncSourceId" :title="asset.syncSourceId" :readonly="true"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-row style="margin: 0">
                                <template v-for="(group, index) in customFieldGroups">
                                    <b-card :class="`no-padding col-md-${group.ref.displayGridColumn}`">
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-row>
                                                <b-col>
                                                    <b-link v-b-toggle="'accordion-group-' + group.ref.text">
                                                        {{ group.ref.text }}
                                                        <span class="when-opened pull-right">
                                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                        </span>
                                                        <span class="when-closed pull-right">
                                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                        </span>
                                                    </b-link>
                                                </b-col>
                                            </b-row>
                                        </b-card-header>

                                        <b-collapse :id="'accordion-group-' + group.ref.text" visible role="tabpanel">
                                            <b-card-body>
                                                <b-row>
                                                    <template v-for="(field, index) in group.fields">
                                                        <template v-if="field.isDisplayed">
                                                            <div class="col-12" v-if="field.displayNewLine"></div>
                                                            <b-col :md="field.displayGridColumn" class="editable">
                                                                <b-form-group :label="getFieldLabel(field)"
                                                                              :label-cols="field.displayLabelColumn"
                                                                              :label-class="getLabelClass(field)"
                                                                              :title="getFieldTitle(field)"
                                                                              :horizontal="true"
                                                                              label-align="left">
                                                                    <template v-if="field.dataType == 'FILE'">
                                                                        <label class="col-form-label"><b-link href="javascript:void(0)" @click="downloadAttachment">{{ getFieldValue(field) }}</b-link></label>
                                                                    </template>
                                                                    <template v-else>
                                                                        <template v-if="field.dataType == 'NUMBER(1,0)' && !field.format">
                                                                            <b-form-checkbox v-model="field.value" disabled="disabled"></b-form-checkbox>
                                                                        </template>
                                                                        <template v-else>
                                                                            <template v-if="typeof(field.value) == 'object' && field.value != null">
                                                                                <json-field :value="field.value"></json-field>
                                                                                <!--<json-viewer :data="JSON.stringify(field.value)"></json-viewer>-->
                                                                            </template>
                                                                            <template v-else>
                                                                                <input-auto-size :value="getFieldValue(field)" :title="getFieldValue(field)" v-if="field.name"></input-auto-size>
                                                                            </template>
                                                                        </template>
                                                                    </template>
                                                                    <!--<b-form-input :value="getFieldValue(field)" :title="getFieldValue(field)" :readonly="true" v-if="field.name"></b-form-input>-->
                                                                </b-form-group>
                                                            </b-col>
                                                            <template v-if="field.name == null && field.displayName.toLocaleLowerCase().indexOf('hien trang') != -1">
                                                                <b-col md="2" v-for="usage in asset.usageStates" :key="usage.id">
                                                                    <b-form-group :label="usage.name"
                                                                                  :title="usage.name"
                                                                                  :horizontal="true"
                                                                                  label-align="left">
                                                                        <b-form-input v-if="usage.isAreaUsage" :value="usage.value | formatNumber" :title="usage.value | formatNumber" :readonly="true"></b-form-input>
                                                                        <b-checkbox disabled v-else v-model="usage.value >= 1"></b-checkbox>
                                                                    </b-form-group>
                                                                </b-col>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </b-row>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </template>
                            </b-row>


                            <b-card style="margin-top: 0" v-if="asset.assetTypeGroupId == 7">
                                <br />
                                <br />
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-row>
                                        <b-col>
                                            <b-link v-b-toggle.accordion-land-houses>
                                                Xem chi tiết nhà trên đất
                                                <span class="when-opened pull-right">
                                                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                </span>
                                                <span class="when-closed pull-right">
                                                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                </span>
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                </b-card-header>
                                <b-collapse id="accordion-land-houses" visible role="tabpanel">
                                    <b-card-body>
                                        <b-grid :gridOptions="landHousesGridOptions"
                                                :items="asset.landHouses"
                                                :showActions="false"
                                                ref="assetDepreciationTable"
                                                gridName="">
                                            <template v-slot:cell(code)="row">
                                                <router-link :to="{ path: `/data/organization-assets/${row.item.id}` }">{{ row.value }}</router-link>
                                            </template>
                                            <template v-slot:cell(originalValue)="row">
                                                {{ row.value | currency }}
                                            </template>
                                            <template v-slot:cell(area)="row">
                                                {{ row.value | formatNumber }} m²
                                            </template>
                                        </b-grid>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </b-tab>
                        <b-tab title="Khấu hao">
                            <br />
                            <b-grid :gridOptions="assetDepreciationGridOptions" id="depreciationTable"
                                    :items="assetDepreciations"
                                    :showActions="isDataOwner"
                                    ref="assetDepreciationTable"
                                    gridName="">
                                <!--<template v-slot:actions v-if="isDataOwner">
                                    <b-button size="md" @click.stop="removeSelectedDepreciation" variant="danger">
                                        Xóa
                                    </b-button>
                                </template>-->
                                <template v-slot:cell(depreciationRate)="row">
                                    {{ row.value * 100 | formatNumber }}%
                                </template>
                                <template v-slot:cell(depreciationValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(accumulatedDepreciationValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(originalValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(residualValue)="row">
                                    {{ row.value | currency }}
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button size="sm" @click.stop="removeDepreciation(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xóa
                                    </b-button>
                                </template>
                            </b-grid>
                        </b-tab>
                        <b-tab title="Hao mòn">
                            <br />
                            <b-grid :gridOptions="assetAmortizationGridOptions" id="amortizationTable"
                                    :items="assetAmortizations"
                                    :showActions="isDataOwner"
                                    ref="assetAmortizationTable"
                                    gridName="">
                                <!--<template v-slot:actions v-if="isDataOwner">
                                    <b-button size="md" @click.stop="removeSelectedAmortization" variant="danger">
                                        Xóa
                                    </b-button>
                                </template>-->
                                <template v-slot:cell(amortizationRate)="row">
                                    {{ row.item.amortizationRate * 100 | formatNumber }} %
                                </template>
                                <template v-slot:cell(amortizationValue)="row">
                                    {{ row.item.amortizationValue | currency }}
                                </template>
                                <template v-slot:cell(accumulatedAmortizationValue)="row">
                                    {{ row.item.accumulatedAmortizationValue | currency }}
                                </template>
                                <template v-slot:cell(originalValue)="row">
                                    {{ row.item.originalValue | currency }}
                                </template>
                                <template v-slot:cell(residualValue)="row">
                                    {{ row.item.residualValue | currency }}
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button size="sm" @click.stop="removeAmortization(row.item, row.index, $event.target)" variant="danger" class="mr-1" title="xóa">
                                        Xóa
                                    </b-button>
                                </template>
                            </b-grid>
                        </b-tab>
                        <!--<b-tab title="Khai thác tài sản">
                            <br />
                            <b-grid :gridOptions="assetExploitationGridOptions" v-if="asset.id"
                                    :items="asset.assetExploitations"
                                    :showActions="isDataOwner"
                                    ref="assetExploitationTable"
                                    gridName="">
                                <template v-slot:cell(startDate)="row">
                                    {{ row.item.startDate | formatDate }}
                                </template>
                                <template v-slot:cell(endDate)="row">
                                    {{ row.item.endDate | formatDate }}
                                </template>
                                <template v-slot:cell(issuedDate)="row">
                                    {{ row.item.issuedDate | formatDate }}
                                </template>
                                <template v-slot:cell(price)="row">
                                    {{ row.item.price | currency }}
                                </template>
                                <template v-slot:cell(exploitedValue)="row">
                                    {{ row.item.exploitedValue | currency }}
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button size="sm" @click.stop="removeExploitation(row.item, row.index, $event.target)" class="mr-1" title="xóa">
                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                    </b-button>
                                </template>
                            </b-grid>
                        </b-tab>-->
                        <b-tab title="Xử lý tài sản">
                            <br />
                            <b-grid :gridOptions="assetHandlingGridOptions" id="handlingTable"
                                    :items="assetHandlings"
                                    :showActions="isDataOwner"
                                    ref="assetHandlingTable"
                                    gridName="">
                                <!--<template v-slot:actions v-if="isDataOwner">
                                    <b-button size="md" @click.stop="removeSelectedHandling" variant="danger">
                                        Xóa
                                    </b-button>
                                </template>-->
                                <template v-slot:cell(handlingDate)="row">
                                    {{ row.item.handlingDate | formatDate }}
                                </template>
                                <template v-slot:cell(status)="row">
                                    {{ row.item.status ? 'Đã xử lý' : 'Đang đề xuất' }}
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button size="sm" @click.stop="removeHandling(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xóa
                                    </b-button>
                                </template>
                            </b-grid>
                        </b-tab>
                        <!--<b-tab title="Kiểm kê tài sản">
                            <br />
                            <b-grid :gridOptions="assetInventoryGridOptions" v-if="asset.id"
                                    :items="asset.assetInventories"
                                    :showActions="false"
                                    gridName="">
                                <template v-slot:cell(originalValue)="row">
                                    {{ row.item.value | currency }}
                                </template>
                                <template v-slot:cell(residualValue)="row">
                                    {{ row.item.value | currency }}
                                </template>
                                <template v-slot:cell(quantity)="row">
                                    {{ row.item.value | formatNumber }}
                                </template>
                                <template v-slot:cell(quantityInventory)="row">
                                    {{ row.item.value | formatNumber }}
                                </template>
                                <template v-slot:cell(quantityDifference)="row">
                                    {{ row.item.value | formatNumber }}
                                </template>
                                <template v-slot:cell(inventoryDte)="row">
                                    {{ row.item.inventoryDte | formatDate }}
                                </template>
                                <template v-slot:cell(relatedMutation)="row">
                                    <router-link :to="{ path: `/data/asset-mutations/${row.item.relatedAssetMutationId}` }">
                                        {{ row.item.relatedAssetMutationTypeName }}
                                    </router-link>
                                </template>
                                <template v-slot:cell(inventoryCode)="row">
                                    <router-link :to="{ path: `/data/asset-inventories/${row.item.inventoryId}` }">
                                        {{ row.value }}
                                    </router-link>
                                </template>
                            </b-grid>
                        </b-tab>-->
                    </b-tabs>
                </b-card>
                <b-card style="margin-top: 0; padding-top: 0">
                    <b-row>
                        <b-col class="text-center">
                            <div class="form-group">
                                <b-button type="button" :to="{ path: '.' }">Quay lại</b-button>
                                <b-button type="button" :to="{ path: `./asset-mutations/list?assetCode=${asset.code}&unitOption=2` }">Danh sách biến động</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>

</template>
<script>
    import { mixins } from '@/shared/mixins'
    import JsonField from '@/components/JsonField';

    export default {
        name: 'AssetDetail',
        mixins: [mixins],
        components: {
            JsonField
        },
        data() {
            return {
                asset: {},
                assetDepreciations: [],
                assetAmortizations: [],
                assetHandlings: [],
                landHousesGridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã nhà', sortable: true },
                        { key: 'name', label: 'Tên nhà', sortable: true },
                        { key: 'assetTypeName', label: 'Cấp hạng nhà', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true },
                        { key: 'area', label: 'Diện tích', sortable: true }
                    ]
                },
                assetDepreciationGridOptions: {
                    fields: [
                        { key: 'year', label: 'Năm khấu hao', sortable: true },
                        { key: 'month', label: 'Số tháng khấu hao', sortable: true },
                        { key: 'depreciationRate', label: 'Tỷ lệ khấu hao', sortable: true },
                        { key: 'depreciationValue', label: 'Khấu hao trong kỳ', sortable: true },
                        { key: 'accumulatedDepreciationValue', label: 'Khấu hao lũy kế', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true },
                        { key: 'residualValue', label: 'Giá trị còn lại', sortable: true }
                    ]
                },
                assetAmortizationGridOptions: {
                    fields: [
                        { key: 'year', label: 'Năm hao mòn', sortable: true },
                        { key: 'amortizationRate', label: 'Tỷ lệ hao mòn', sortable: true },
                        { key: 'amortizationValue', label: 'Hao mòn trong kỳ', sortable: true },
                        { key: 'accumulatedAmortizationValue', label: 'Hao mòn lũy kế', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true },
                        { key: 'residualValue', label: 'Giá trị còn lại', sortable: true }
                    ]
                },
                assetExploitationGridOptions: {
                    fields: [
                        { key: 'exploitationTypeName', label: 'Hình thức khai thác', sortable: true },
                        { key: 'startDate', label: 'Ngày bắt đầu', sortable: true },
                        { key: 'endDate', label: 'Ngày kết thúc', sortable: true },
                        { key: 'decisionCode', label: 'Số quyết định', sortable: true },
                        { key: 'issuedDate', label: 'Ngày quyết định', sortable: true },
                        { key: 'approver', label: 'Người quyết định', sortable: true },
                        { key: 'price', label: 'Đơn giá', sortable: true },
                        { key: 'exploitedTime', label: 'Thời gian khai thác', sortable: true },
                        { key: 'exploitedValue', label: 'Số tiền thu được', sortable: true },
                        { key: 'contract', label: 'Hợp đồng liên quan', sortable: true },
                        { key: 'partner', label: 'Đối tác/đơn vị thuê', sortable: true },
                        { key: 'notes', label: 'Ghi chú', sortable: true }
                    ]
                },
                assetHandlingGridOptions: {
                    fields: [
                        { key: 'decisionNumber', label: 'Quyết định xử lý', sortable: true },
                        { key: 'handlingDate', label: 'Ngày xử lý', sortable: true },
                        { key: 'status', label: 'Trạng thái', sortable: true },
                        { key: 'handlingResult', label: 'Kết quả xử lý', sortable: true },
                        { key: 'notes', label: 'Ghi chú', sortable: true }
                    ]
                },
                assetInventoryGridOptions: {
                    fields: [
                        { key: 'inventoryCode', label: 'Mã biên bản', sortable: true },
                        { key: 'inventoryName', label: 'Tên đợt KK', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true },
                        { key: 'residualValue', label: 'Giá trị còn lại', sortable: true },
                        { key: 'quantity', label: 'Số lượng KT', sortable: true },
                        { key: 'quantityInventory', label: 'Số lượng KK', sortable: true },
                        { key: 'quantityDifference', label: 'Chênh lệch', sortable: true },
                        { key: 'usageState', label: 'Tình trạng SD', sortable: true },
                        { key: 'handlingProposed', label: 'Đề xuất xử lý', sortable: true },
                        { key: 'handlingResult', label: 'Kết quả xử lý', sortable: true },
                        { key: 'relatedMutation', label: 'Biến động TS', sortable: true },
                        { key: 'notes', label: 'Ghi chú', sortable: true },
                    ]
                }
            }
        },
        computed: {
            assetId() {
                return this.$route.params.assetId;
            },
            customFieldGroups() {
                if (!this.asset.customFields || this.asset.customFields.length == 0) return [];

                var data = this.asset.customFields;
                var groupBy = _(data).groupBy(x => x.groupId).sortBy(group => data.indexOf(group[0])).value();
                var groups = [];

                for (var i = 0; i < groupBy.length; i++) {
                    groups.push({ ref: groupBy[i][0].group || { text: 'undefined' }, fields: groupBy[i] });
                }

                return groups;
            },
            isDataOwner() {
                return this.authorize(['QLTSC_ManageAsset', 'CTNS_ManageAsset', 'HTGTDB_ManageAsset'], this.asset.syncUnitId);
            }
        },
        created() {
            this.loadAssetDetail();
        },
        methods: {
            loadAssetDetail() {
                var vm = this;
                this.$services.get(`data/assets/${this.assetId}`).done(asset => {
                    for (var i = 0; i < asset.customFields.length; i++) {
                        if (asset.customFields[i].groupId) {
                            asset.customFields[i].group = asset.customGroups.find(x => x.id == asset.customFields[i].groupId);
                        }
                    }

                    vm.asset = asset;
                    scrollToTop();
                });

                this.$services.get(`data/assets/${this.assetId}/depreciations`, null, { showLoading: false }).done(response => {
                    this.assetDepreciations = response;
                });

                this.$services.get(`data/assets/${this.assetId}/amortizations`, null, { showLoading: false }).done(response => {
                    this.assetAmortizations = response;
                });

                this.$services.get(`data/assets/${this.assetId}/handlings`, null, { showLoading: false }).done(response => {
                    this.assetHandlings = response;
                });
            },
            getLabelClass(field) {
                var classes = '';

                //if (field.isRequired) {
                //    classes += ' required';
                //}

                if (field.displayLabelBold) {
                    classes += ' label-bold';
                }

                if (field.displayLabelItalic) {
                    classes += ' label-italic';
                }

                if (field.displayLabelNone) {
                    classes += ' label-none';
                }

                return classes;
            },
            getFieldLabel(field) {
                var index = field.displayName.indexOf('.');
                return index == - 1 ? field.displayName : field.displayName.substr(0, index);
            },
            getFieldTitle(field) {
                return field.name;
                //var index = field.displayName.indexOf('.');
                //return index == - 1 ? null : field.displayName.substr(index);
            },
            getFieldValue(field) {
                if (field.name == "OTHER_INFORMATION") {
                    try {
                        var jsonObj = JSON.parse(field.value);
                        var value = '';

                        for (var p in jsonObj) {
                            if (value != '') {
                                value += '\n';
                            }
                            value += `- ${p} : ${jsonObj[p]}`;
                        }
                        return value;
                    } catch {
                        return field.value;;
                    }
                }


                if (field.format != null) {
                    return field.format;
                } else if (field.lookupValue != null) {
                    return field.lookupValue;
                }

                return field.value;
            },
            removeDepreciation(item) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa thông tin khấu hao này?')) {
                    this.$services.delete(`data/asset-depreciations/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa thông tin khấu hao thành công');
                        vm.assetDepreciations.remove(item);
                    });
                }
            },
            removeAmortization(item) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa thông tin hao mòn này?')) {
                    this.$services.delete(`data/asset-amortizations/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa thông tin hao mòn thành công');
                        vm.assetAmortizations.remove(item);
                    });
                }
            },
            //removeExploitation(item) {
            //    var vm = this;
            //    if (confirm('Bạn có chắc chắn muốn xóa thông tin khai thác này?')) {
            //        this.$services.delete(`data/asset-exploitations/${item.id}`).done(() => {
            //            vm.$toastr.s('Xóa thông tin khai thác thành công');
            //            vm.asset.assetExploitations.remove(item);
            //        });
            //    }
            //},
            removeHandling(item) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa thông tin xử lý này?')) {
                    this.$services.delete(`data/asset-handlings/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa thông tin xử lý thành công');
                        vm.assetHandlings.remove(item);
                    });
                }
            },
            removeSelectedDepreciation() {
                var vm = this;
                var selectedRows = this.$refs.assetDepreciationTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các thông tin khấu hao này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/asset-depreciations?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các thông tin khấu hao thành công');

                            for (var i = 0; i < selectedRows.length; i++) {
                                vm.assetDepreciations.remove(selectedRows[i]);
                            }
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn thông tin khấu hao cần xóa');
                }
            },
            removeSelectedAmortization() {
                var vm = this;
                var selectedRows = this.$refs.assetAmortizationTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các thông tin hao mòn này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/asset-amortizations?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các thông tin hao mòn thành công');

                            for (var i = 0; i < selectedRows.length; i++) {
                                vm.assetAmortizations.remove(selectedRows[i]);
                            }
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn thông tin hao mòn cần xóa');
                }
            },
            //removeSelectedExploitation() {
            //    var vm = this;
            //    var selectedRows = this.$refs.assetExploitationTable.selectedRows;
            //    if (selectedRows.length > 0) {
            //        if (confirm('Bạn có chắc chắn muốn xóa các thông tin khai thác này?')) {
            //            var data = selectedRows.map(x => x.id).join(',');
            //            this.$services.delete(`data/asset-exploitations?ids=${data}`).done(() => {
            //                vm.$toastr.s('Xóa các thông tin khai thác thành công');

            //                for (var i = 0; i < selectedRows.length; i++) {
            //                    vm.asset.assetExploitations.remove(selectedRows[i]);
            //                }
            //            });
            //        }
            //    }
            //    else {
            //        vm.$toastr.e('Vui lòng chọn thông tin khai thác cần xóa');
            //    }
            //},
            removeSelectedHandling() {
                var vm = this;
                var selectedRows = this.$refs.assetHandlingTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các thông tin xử lý này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/asset-handlings?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các thông tin xử lý thành công');

                            for (var i = 0; i < selectedRows.length; i++) {
                                vm.assetHandlings.remove(selectedRows[i]);
                            }
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn thông tin xử lý cần xóa');
                }
            },
            downloadAttachment() {
                this.$services.download(`data/assets/${this.assetId}/attachment`);
            }
        },
        watch: {
            assetId() {
                this.loadAssetDetail();
            }
        }
    }
</script>
<style scoped>

    label {
        font-weight: 400;
        font-style: italic;
    }

    .text-1 {
        font-weight: 500;
    }

    .card {
        margin-bottom: 0;
        margin-top: 1rem;
        border: none;
    }
</style>
